import { UnitsDescriptionRead } from "@types";
import { STRING } from "@constants";

const T = STRING.SIZE_DETAILS;
const U = STRING.GATE_DETAILS;
const L = STRING.LOCATION_DETAILS;

export function getSizesDetails(data?: UnitsDescriptionRead | null) {
  if (!data) return { sections: [] };

  const sections: any[] = [];

  sections.push({
    title: T.FLOOR || "Floor",
    icon: "pi-building",
    fields: [{ label: T.FLOOR || "Floor", value: data.floor }],
  });

  sections.push({
    title: T.SECTION_DESCRIPTIONS || "Extended Descriptions",
    icon: "pi-align-left",
    fields: [
      { label: T.DESCRIPTION_1 || "Description 1", value: data.description1 },
      { label: T.DESCRIPTION_2 || "Description 2", value: data.description2 },
      { label: T.DESCRIPTION_3 || "Description 3", value: data.description3 },
      { label: T.DESCRIPTION_4 || "Description 4", value: data.description4 },
    ],
  });

  if (data.unit) {
    const unit = data.unit;
    sections.push({
      title: U.UNIT_NAME || "Unit",
      icon: "pi-box",
      fields: [
        { label: "Name", value: unit.name },
        { label: "Type", value: unit.type },
        { label: "Status", value: unit.status },
        { label: "Condition", value: unit.condition },
        { label: "Width", value: unit.width },
        { label: "Length", value: unit.length },
        { label: "Sq. Footage", value: unit.sqFootage },
        { label: "Initial Price", value: unit.initialPrice },
        { label: "Sale Price", value: unit.salePrice },
      ],
    });
  }

  if (data.unit?.size) {
    const size = data.unit.size;
    sections.push({
      title: T.SIZE || "Size",
      icon: "pi-ruler",
      fields: [
        { label: "Description", value: size.description },
        { label: "Width", value: size.width },
        { label: "Length", value: size.length },
        { label: "Category ID", value: size.unitCategoryId },
        { label: "Image URL", value: size.imageUrl },
      ],
    });
  }

  if (data.unit?.location) {
    const loc = data.unit.location;
    sections.push({
      title: L.LOCATION || "Location",
      icon: "pi-map-marker",
      fields: [
        { label: "Name", value: loc.locationName },
        { label: "Address", value: loc.address },
        { label: "Address 2", value: loc.address2 },
        { label: "City", value: loc.city },
        { label: "State", value: loc.state },
        { label: "Zip Code", value: loc.zipCode },
        { label: "Phone", value: loc.phone },
        { label: "Email", value: loc.email },
        { label: "Hours Weekdays", value: loc.hoursWeekdays },
        { label: "Hours Weekends", value: loc.hoursSaturday },
        { label: "Hours Weekends", value: loc.hoursSunday },
        { label: "Gate Hours", value: loc.gateHours },
        { label: "Latitude", value: loc.latitude },
        { label: "Longitude", value: loc.longitude },
        { label: "Processor Customer ID", value: loc.processorCustomerId },
        { label: "Processor Type", value: loc.processorType },
      ],
    });
  }

  return { sections };
}
